import { CSSProperties, memo, useState } from 'react';

import InputWithOverlay from '@ui/input-with-overlay/input-with-overlay';
import OptionalComponent from '@ui/optional-component/optional-component';
import Text from '@ui/text/text/text';

import styles from './add-new-session-name.module.css';

type AddNewSessionNameProps = {
  onDebounce: (value: string) => void;
  onBlur: (value: string) => void;
  name: string;
  nameAlreadyExists: boolean;
  savingSession: boolean;
};

const AddNewSessionName = memo(
  ({ savingSession, nameAlreadyExists, onDebounce, onBlur, name }: AddNewSessionNameProps) => {
    const [dirty, setDirty] = useState(false);

    return (
      <div>
        <InputWithOverlay
          inputHeight="32px"
          inputProps={{
            placeholder: 'Give your session a name',
            className: `H4 padding-0 radius-4 ${styles.sessionNameInput}`,
            style: { '--input-placeholder-color': 'var(--gray-400)' } as CSSProperties,
            onBlur: (e) => {
              e.target.value = e.target.value.trim(); // overwrite the input value to remove spaces
              onBlur(e.target.value);
              setDirty(true);
            },
            onFocus: () => setDirty(false),
          }}
          border="1px solid transparent"
          error={(!savingSession && dirty && !name.trim().length) || nameAlreadyExists}
          onDebounce={onDebounce}
          debounceTime={250}
        />
        <OptionalComponent display={!savingSession && nameAlreadyExists}>
          <Text className="C2" color="var(--semantic-red-500)">
            Session name already exists
          </Text>
        </OptionalComponent>
      </div>
    );
  }
);

export default AddNewSessionName;
